import { helper } from '@ember/component/helper';

/**
 * Convert a number to its ordinal form (1st, 2nd, 3rd, etc.)
 */
export function ordinal([number]) {
  if (number === null || number === undefined || number === '') {
    return '';
  }

  const n = parseInt(number, 10);
  if (isNaN(n)) {
    return '';
  }

  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
  return `${n}${suffix}`;
}

export default helper(ordinal);
